import { Award, Trophy } from "lucide-react";
import { AWARDS } from "@/data/content";
import SectionBadge from "@/components/site/SectionBadge";

export default function Awards() {
  return (
    <section
      id="awards"
      data-testid="awards-section"
      className="pt-2 md:pt-4 pb-20 md:pb-24 bg-[#F2F2F2]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <SectionBadge label="Recognition" icon={<Trophy className="h-3.5 w-3.5" />} />
        <div className="mt-6 grid grid-cols-12 gap-6 md:gap-10 mb-10">
          <div className="col-span-12 md:col-span-5">
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-[1.05]">
              Award-winning, <br />
              proven leadership.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-7 md:flex md:flex-col md:justify-end">
            <p className="text-lg text-zinc-600 leading-relaxed max-w-lg">
              A partner recognized by peers, publications and industry bodies
              for driving measurable transformation across categories.
            </p>
          </div>
        </div>

        <ul className="border-t border-zinc-300">
          {AWARDS.map((a, i) => (
            <li
              key={i}
              data-testid={`award-item-${i}`}
              className="group flex items-center gap-4 md:gap-8 py-6 md:py-8 border-b border-zinc-300 transition-colors duration-300 hover:bg-white"
            >
              <div className="w-10 md:w-14 shrink-0 font-serif-display text-2xl md:text-3xl text-zinc-400 group-hover:text-black tabular transition-colors duration-300">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-serif-display text-lg md:text-2xl text-black leading-tight">
                  {a.title}
                </div>
                <div className="mt-1 text-sm text-zinc-500">{a.body}</div>
              </div>
              <div className="shrink-0 text-sm font-medium text-zinc-600 tabular whitespace-nowrap w-16 md:w-24 text-right">
                {a.year}
              </div>
              <div className="shrink-0 flex items-center justify-center w-6">
                <Award className="h-5 w-5 text-zinc-400 group-hover:text-black transition-colors duration-300" />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
